import { createStyles, makeStyles } from '@material-ui/core';
export const MIN_CONTENT_WIDTH = 1440;
export const useStyles = makeStyles(() => createStyles({
    '@global': {
        html: {
            minWidth: MIN_CONTENT_WIDTH,
        },
    },
}));
